import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";

function Searchbar({ onSearch, initialValue = '' }) {
  const [inputValue, setInputValue] = useState(initialValue);
  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    onSearch(value);
  };

  const handleClear = () => {
    setInputValue('');
    onSearch('');
  };

  return (
    <div className="searchbar-container-collab">
      <div className="searchbar-input-wrapper">
        <input
          type="text"
          placeholder="Search collaborations..."
          value={inputValue}
          onChange={handleChange}
          className="searchbar-input"
        />
        {inputValue && (
          <button onClick={handleClear} className="searchbar-clear">
            ×
          </button>
        )}
        <span className="searchbar-icon">
           <FaSearch />
        </span>
      </div>
    </div>
  );
}

export default Searchbar;